import React from 'react'
import { RenderNode } from '~core/RenderNode'
import { Node, Nodes } from '~core/global.type'

type BuildBlockParams = {
  shardId: number
  node: Node
  nodes: Nodes
}

export const buildBlockElements = ({
  shardId,
  node,
  nodes,
}: BuildBlockParams): React.ReactElement => {
  let children: any
  if (typeof node.props.children === 'string' && node.children.length === 0) {
    children = node.props.children
  } else if (node.children.length) {
    children = node.children.map((nodeId: any) =>
      buildBlockElements({ shardId, node: nodes[nodeId], nodes }),
    )
  }

  return (
    <RenderNode key={`${shardId}-${node?.id}`} node={node}>
      {children}
    </RenderNode>
  )
}
